/*
* Copy address to clipboard component
*/

import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as React from 'react';
import * as _ from 'lodash';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import * as ReduxQueries from '../queries';
import { Formatters } from './formatters';

export interface ICopyAddressToClipboardProps extends AppComp.IAppComponentProps {
    locationObj?: any;
}

export interface ICopyAddressToClipboardState extends AppComp.IAppComponentState {
    showModalAddressCopied: boolean;
}

class CopyAddressToClipboard extends AppComp.AppComponentNoWrapper<ICopyAddressToClipboardProps, ICopyAddressToClipboardState> {
    public static defaultProps = {
        locationObj: {},
    };

    public constructor(props: ICopyAddressToClipboardProps) {
        super(props, 'app.copy-address-to-clipboard.');

        this.state = {
            showModalAddressCopied: false,
        };
    }

    public closeModal() {
        this.setState({ showModalAddressCopied: false });
    }

    public showModal() {
        this.setState({ showModalAddressCopied: true });
    }

    public render() {
        const { locationObj } = this.props;

        let copyAddressLink;
        if (locationObj && !_.isEmpty(locationObj)) {
            const formattedAddress = Formatters.composeLocationFullAddress(locationObj);

            copyAddressLink = (
                <div>
                    <CopyToClipboard text={formattedAddress} onCopy={(text) => { this.showModal(); }}>
                        <span className="copy-address-link"><i className="fa fa-clipboard" aria-hidden="true" /> {this.appText('copy-address-to-clipboard')}</span>
                    </CopyToClipboard>

                    <Modal show={this.state.showModalAddressCopied} onHide={() => this.closeModal()}>
                        <Modal.Header closeButton={true}>
                            <Modal.Title>{this.appText('address-copied')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4>{this.appText('address-has-been-copied')}:</h4>
                            <p>{formattedAddress}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.closeModal()}>{this.appText('app.common.buttons.close', false)}</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            );
        }

        return (
            <div>
                {copyAddressLink}
            </div>
        );
    }
}

const mapStateToProps = (state: ICopyAddressToClipboardState, props): ICopyAddressToClipboardProps => {
    const mapped = ReduxQueries.MapQueryStateToPropsRoot(state, props, null);

    return mapped;
};

const CopyAddressToClipboardContainer = connect(mapStateToProps, {})(CopyAddressToClipboard);

export default withRouter<ICopyAddressToClipboardProps>(CopyAddressToClipboardContainer);



// WEBPACK FOOTER //
// ./src/common/copyaddresstoclipboard.tsx